import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import getExtPath from 'shared-utils/src/getExtPath';

import { mainCls as detailsCls } from '../../style';

export const mainCls =  `${detailsCls}__feats`;
export const mapCls =  `map_${detailsCls}__feats`;

const brTablet = createBreakpoint('s');
const brDesk = createBreakpoint('m');
const brLarge = createBreakpoint('l');

export default {
  [`${mainCls}__descCont`]: {
    marginTop: 16,
    [brTablet]: {
      marginTop: 0,
    },
  },
  [`${mapCls}__descCont`]: {
    marginTop: 16,
  },  
  [`${mainCls}__desc`]: {
    flex: '1 1 0%',
    overflow: 'hidden',
    lineHeight: '20px',
    whiteSpace: 'break-spaces',
    transition: createTransition(['max-height']),
    
    '&.clamped': {
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      
      [brTablet]: {
        '-webkit-line-clamp': 3,
      },
      [brDesk]: {
        '-webkit-line-clamp': 2,
      },
      [brLarge]: {
        '-webkit-line-clamp': 3,
      },    
      '&.medium' : {
        [brTablet]: {
          '-webkit-line-clamp': 2,
        },
        [brDesk]: {
          '-webkit-line-clamp': 1,
        },
        [brLarge]: {
          '-webkit-line-clamp': 2,
        },
      },      
      '&.less' : {
        [brTablet]: {
          '-webkit-line-clamp': 1,
        },
        [brDesk]: {
          '-webkit-line-clamp': 1,
        },
        [brLarge]: {
          '-webkit-line-clamp': 1,
        },
      },
    },
  },
  [`${mapCls}__desc`]: {
    flex: '1 1 0%',
    overflow: 'hidden',
    lineHeight: '20px',
    whiteSpace: 'break-spaces',
    transition: createTransition(['max-height']),
    
    '&.clamped': {
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
    },
  },
  [`${mainCls}__desc--expandCont`]: {
    flex: '0 1 auto',
    height: 14,
    opacity: 0,
    transition: createTransition(['opacity']),
    '&.visible': {
      opacity: 1,
    },
  },
  [`${mainCls}__desc--expand`]: {
    margin: 0,
    padding: 0,
    width: 22,
    height: 14,
    background: `transparent url(${getExtPath('/common_images/common/ReadMore.svg')}) 50% 50% no-repeat`,
    borderColor: `${colors.border.rgba} !important`,
    borderRadius: 4,
    '&:after': {
      content: '""',
      position: 'absolute',
      top: -13,
      left: -9,
      width: 40,
      height: 40,
    },
    [brTablet]: {
      // borderColor: `${colors.border.rgba} !important`,
      transition: createTransition(['border-color']),
      '&:hover': {
        borderColor: `${colors.secondary.rgba} !important`,        
      },
      '&:after': {
        content: '',
      },
    },
  },
};
